import React from "react";
import styled from "styled-components";

export type OfficeSummary = {
    id: string;
    name: string;
    ceo: string;
    address: string;
};

type Props = {
    item: OfficeSummary;
    onClick?: () => void;
    className?: string;
};

const OfficeSummaryBox: React.FC<Props> = ({ item, onClick, className }) => {
    return (
        <Box
            role="button"
            tabIndex={0}
            onClick={onClick}
            onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onClick?.()}
            className={className}
        >
            <Row>
                <Label>상호</Label>
                <Value>{item.name}</Value>
            </Row>
            <Row>
                <Label>대표</Label>
                <Value>{item.ceo}</Value>
            </Row>
            <Row>
                <Label>소재지</Label>
                <Value className="multiline">{item.address}</Value>
            </Row>
        </Box>
    );
};

export default OfficeSummaryBox;

const Box = styled.div`
    border: 1px solid #e6e8ec;
    padding: 14px 12px;
    background: #fff;
    cursor: pointer;
    outline: none;

    &:focus-visible {
        box-shadow: 0 0 0 3px rgba(0, 120, 255, 0.15);
    }
`;

const Row = styled.div`
    display: grid;
    grid-template-columns: 64px 1fr;
    column-gap: 14px;

    & + & {
        margin-top: 12px;
    }
`;

const Label = styled.div`
    color: #505050;
    font-size: 14px;
    font-weight: 400;
    line-height: 140%;
`;

const Value = styled.div`
    color: #161a2a;
    font-size: 14px;
    line-height: 1.6;
    font-weight: 400;
    &.multiline {
        white-space: pre-line;
    }
`;